import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import ColorPalettePreview from "discourse/components/color-palette-preview";
import { i18n } from "discourse-i18n";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const ColorPalettePickerRow = dt7948.c(class ColorPalettePickerRow extends SelectKitRowComponent {
  get active() {
    return this.item?.id === this.value;
  }
  static {
    dt7948.n(this.prototype, "active", [computed("item.id", "value")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.active}}\n      <span class=\"color-palette-picker-row__badge --active\">\n        {{i18n \"user.color_schemes.picker.active\"}}\n      </span>\n    {{/if}}\n    <ColorPalettePreview class=\"color-palette-picker-row__preview\" @scheme={{@item}} />\n    <div class=\"color-palette-picker-row__name\">\n      {{@item.name}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        i18n,
        ColorPalettePreview
      })
    }), this);
  }
}, [classNames("color-palette-picker-row")]);
export default ColorPalettePickerRow;